



































import {
  defineComponent,
  ref,
  computed,
  PropType
} from '@nuxtjs/composition-api'
import { FilterOption } from '~/models/statistics/types'
import CCheckbox from '~/components/shared/configurable/form/checkbox/CCheckbox.vue'

export default defineComponent({
  components: { CCheckbox },
  props: {
    options: {
      type: Array as PropType<FilterOption[]>,
      default: () => []
    },
    selected: {
      type: Array as PropType<number[]>,
      default: () => []
    },
    filterGroupType: {
      type: String,
      required: true
    },
    showMoreButton: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  setup(props, { emit }) {
    const more = ref(false)

    const toggleMore = () => {
      more.value = !more.value
    }

    const onFilterChange = (option: FilterOption) => {
      emit('change-filter', {
        type: props.filterGroupType,
        value: option.value
      })
    }

    const showOptions = computed(() => {
      return more.value ? props.options : props.options.slice(0, 5)
    })

    return {
      more,
      showOptions,
      toggleMore,
      onFilterChange
    }
  }
})
